<template>
  <div id="statsThree"></div>
</template>

<script>
export default {
  name: "StatsThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        number: "147%",
        label: "Revenue Growth",
        subtitle: "Q4 2025 vs Q4 2024",
        chip: "Company Update",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("statsThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const numberSize = exporting ? 280 : 280 * this.scale;
      const labelSize = exporting ? 44 : 44 * this.scale;
      const subtitleSize = exporting ? 24 : 24 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Giant decorative number in background -->
          <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: ${numberSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.04;
            line-height: 1;
            pointer-events: none;
            user-select: none;
            white-space: nowrap;
          ">${this.data.number}</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Stats content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${numberSize * 0.5}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 700;
              color: #1a1a1a;
              line-height: 1;
              letter-spacing: -0.02em;
              margin-bottom: 24px;
            ">${this.data.number}</div>

            <div style="margin-bottom: 32px;">
              <p style="
                color: #1a1a1a;
                font-size: ${labelSize}px;
                margin: 0;
                font-weight: 700;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                letter-spacing: -0.01em;
                display: inline-block;
                position: relative;
              ">
                ${this.data.label}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 100%;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </p>
              <p style="
                color: #666666;
                font-size: ${subtitleSize}px;
                margin: 20px 0 0 0;
                font-weight: 400;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
              ">${this.data.subtitle}</p>
            </div>

            <!-- Chip -->
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
